var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, Input } from '@angular/core';
import { ColumnBaseComponent } from '../../../../../items/columns/base/columnbase.component';
import { ColumnService } from '../../../../../items/columns/column/column.service';
import { ColumnBaseService } from '../../../../../items/columns/base/columnbase.service';
import { KtsConstructionClassificationService } from './construction-classification.service';
import { ItemBase } from '../../../../../models/item/item-base';
import { RequestQuery } from '../../../../../component/list/list.service';
var KtsConstructionClassificationComponent = /** @class */ (function (_super) {
    __extends(KtsConstructionClassificationComponent, _super);
    function KtsConstructionClassificationComponent(service, baseService, constClassService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.constClassService = constClassService;
        _this.cols = {};
        return _this;
    }
    KtsConstructionClassificationComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        // view
        if (changes.val && !this.classification && this.middleClassification) {
            this.constClassService.setBaseUrl('/v1/gen/construction-middle-classification-api');
            this.constClassService.getRecord(this.middleClassification).subscribe(function (rec) {
                _this.constClassService.getType('CONSTRUCTION_MIDDLE_CLASSIFICATION', _this.getQuery(rec.construction_classification_id)).subscribe(function (options) {
                    _this.cols['constMiddleClass'].params.options = options;
                    _this.changeVal.emit({ key: _this.cols['constClass'].key, val: rec.construction_classification_id });
                    _this.changeVal.emit({ key: _this.cols['constMiddleClass'].key, val: rec.id });
                });
            });
        }
        _super.prototype.ngOnChanges.call(this, changes);
    };
    KtsConstructionClassificationComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        var constClass = jsonpath.value(this.col, '$.params.classification.key');
        this.cols['constClass'] = this.getCol(constClass, [], true);
        this.constClassService.getType('CONSTRUCTION_CLASSIFICATION').subscribe(function (options) {
            _this.cols['constClass'] = _this.getCol(constClass, options, true);
        });
        var constMiddleClass = jsonpath.value(this.col, '$.params.middleClassification.key');
        this.cols['constMiddleClass'] = this.getCol(constMiddleClass, [], false);
        if (this.classification) {
            // confirm, search
            this.constClassService.getType('CONSTRUCTION_MIDDLE_CLASSIFICATION', this.getQuery(this.classification)).subscribe(function (options) {
                _this.cols['constMiddleClass'] = _this.getCol(constMiddleClass, options, false);
            });
        }
    };
    KtsConstructionClassificationComponent.prototype.getCol = function (key, options, constClassFlg) {
        return Object.assign(new ItemBase(), {
            key: key,
            controlType: 'select',
            readonly: this.col.readonly,
            required: (this.key === 'forminline' ? false : true),
            params: {
                unselectedOption: {
                    hidden: false,
                    display: (constClassFlg ? this.msg['au.COMPONENT.KtsConstructionClassificationComponent.select.classification'] : this.msg['au.COMPONENT.KtsConstructionClassificationComponent.select.middle_classification'])
                },
                options: options
            }
        });
    };
    KtsConstructionClassificationComponent.prototype.getQuery = function (id) {
        return Object.assign(new RequestQuery(), {
            limit: '',
            offset: 0,
            predicateList: [{ name: 'construction_classification_m.id', value: id, operator: 'eq' }]
        });
    };
    KtsConstructionClassificationComponent.prototype.onChangeConstClass = function (id) {
        var _this = this;
        this.changeValFlg = true;
        this.changeVal.emit({ key: this.cols['constClass'].key, val: id });
        this.changeVal.emit({ key: this.cols['constMiddleClass'].key, val: '' });
        this.constClassService.setOption(this.componentName, this.cols['constClass'].key, id, this.cols['constClass'].params.options);
        this.constClassService.setOption(this.componentName, this.cols['constMiddleClass'].key, id, []);
        if (id) {
            this.constClassService.getType('CONSTRUCTION_MIDDLE_CLASSIFICATION', this.getQuery(id)).subscribe(function (options) {
                delete _this.cols['constMiddleClass']; // optionsを反映するために一旦削除する
                var constMiddleClass = jsonpath.value(_this.col, '$.params.middleClassification.key');
                _this.cols['constMiddleClass'] = _this.getCol(constMiddleClass, options, false);
            });
        }
        else {
            delete this.cols['constMiddleClass']; // optionsを反映するために一旦削除する
            var constMiddleClass = jsonpath.value(this.col, '$.params.middleClassification.key');
            this.cols['constMiddleClass'] = this.getCol(constMiddleClass, [], false);
        }
    };
    KtsConstructionClassificationComponent.prototype.onChangeConstMiddleClass = function (id) {
        this.changeValFlg = true;
        this.changeVal.emit({ key: this.cols['constMiddleClass'].key, val: id });
        this.constClassService.setOption(this.componentName, this.cols['constMiddleClass'].key, id, this.cols['constMiddleClass'].params.options);
    };
    KtsConstructionClassificationComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
    };
    KtsConstructionClassificationComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-column-construction-classification',
                    template: "<ul [key]=\"key\" [col]=\"col\" columnDir>\n  <ng-template [ngIf]=\"cols.constClass\">\n    <li *ngIf=\"!cols.constClass.readonly\" class=\"form_li\">\n      <column-select [key]=\"key\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"cols.constClass\" [val]=\"val[cols.constClass.key]\" [msg]=\"msg\" (changeVal)=\"onChangeConstClass($event.val)\"></column-select>\n    </li>\n    <li *ngIf=\"cols.constClass.readonly\" class=\"form_li\">\n      <column-formreadonly [componentName]=\"componentName\" [index]=\"index\" [col]=\"cols.constClass\" [val]=\"val[cols.constClass.key]\" [msg]=\"msg\"></column-formreadonly>\n    </li>\n  </ng-template>\n  <ng-template [ngIf]=\"cols.constMiddleClass\">\n    <li *ngIf=\"!cols.constMiddleClass.readonly\" class=\"form_li\">\n      <column-select [key]=\"key\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"cols.constMiddleClass\" [val]=\"val[cols.constMiddleClass.key]\" [msg]=\"msg\" (changeVal)=\"onChangeConstMiddleClass($event.val)\"></column-select>\n    </li>\n    <li *ngIf=\"cols.constMiddleClass.readonly\" class=\"form_li\">\n      <column-formreadonly [componentName]=\"componentName\" [index]=\"index\" [col]=\"cols.constMiddleClass\" [val]=\"val[cols.constMiddleClass.key]\" [msg]=\"msg\"></column-formreadonly>\n    </li>\n  </ng-template>\n</ul>\n"
                }] }
    ];
    /** @nocollapse */
    KtsConstructionClassificationComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: KtsConstructionClassificationService }
    ]; };
    KtsConstructionClassificationComponent.propDecorators = {
        classification: [{ type: Input }],
        middleClassification: [{ type: Input }]
    };
    return KtsConstructionClassificationComponent;
}(ColumnBaseComponent));
export { KtsConstructionClassificationComponent };
//# sourceMappingURL=construction-classification.component.js.map